// 展览相关接口
import request from '@/utils/request'

// 展览详情接口
export function getExhibitDetails(id) {
  return request({
    url: `/cultureCantonDemoApi/exhibitBasicInfoApi/getExhibitBasicInfoDetails?id=${id}`,
    method: 'get',
  })
}

// 根据展览id查询展品接口
export function getExhibit(data) {
  return request({
    url: `/cultureCantonDemoApi/exhibitItemInfoApi/queryExhibitItemInfoList?exhibitId=${data.exhibitId}&page=${data.page}&size=${data.size}`,
    method: 'get',
  })
}

// 展品详情接口
export function getExhibitItemDetails(id) {
  return request({
    url: `/cultureCantonDemoApi/exhibitItemInfoApi/getExhibitItemDetails?id=${id}`,
    method: 'get',
  })
}
